/**
 * Executes a callback fn when document is ready - this is a polyfill for $(document).ready from JQuery
 * @param {function(): any} fn Function that will execute when the document has fired the DomContentLoaded event, or the document is no longer in loading state
 * @returns {void}
 */
export function onDocumentReady(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}
